import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from '@xo-union/tk-component-icons';
import { Body2 } from '@xo-union/tk-ui-typography';

import { WeddingWebsiteQuery } from '../../generated/graphql';
import { ADD_WEDDING_DATE_COPY } from '../../helpers/useDatePref';
import { basicInfoRailRoute } from '../../helpers/routes';
import LinkButton from '../LinkButton';
import styles from './basicInfoText.scss';

interface Props {
  data?: WeddingWebsiteQuery;
  weddingDateText: string;
  showExperiment?: boolean;
}

const BasicInfoItemText: React.FC<Props> = ({ data, weddingDateText, showExperiment = false }) => {
  const weddingWebsite = data?.weddingWebsite || null;
  const weddingLocation = weddingWebsite?.weddingLocation || null;
  const history = useHistory();
  const { pathname } = useLocation();

  const openBasicInfoEdit = () => {
    history.push(basicInfoRailRoute(pathname.includes('preview')));
  };

  return (
    <>
      <div className={showExperiment ? styles.basicInfoText : styles.infoText}>
        <Icon name="date" className={showExperiment ? styles.icon : styles.infoIcon} />
        {weddingDateText !== ADD_WEDDING_DATE_COPY ? (
          <Body2 data-testid="wedding-date" className={showExperiment ? styles.info : styles.weddingInfo}>
            {weddingDateText}
          </Body2>
        ) : (
          <LinkButton
            className={styles.linkButton}
            data-testid="add-wedding-date"
            color={showExperiment ? 'secondary' : 'primary'}
          >
            {weddingDateText}
          </LinkButton>
        )}
      </div>
      <div className={showExperiment ? styles.basicInfoText : styles.infoText}>
        <Icon name="address" className={showExperiment ? styles.icon : styles.infoIcon} />
        {weddingLocation ? (
          <Body2 data-testid="wedding-location" className={showExperiment ? styles.info : styles.weddingInfo}>
            {weddingLocation}
          </Body2>
        ) : (
          <LinkButton
            onClick={openBasicInfoEdit}
            className={styles.linkButton}
            data-testid="add-wedding-location"
            color={showExperiment ? 'secondary' : 'primary'}
          >
            Add your wedding location
          </LinkButton>
        )}
      </div>
    </>
  );
};

export default BasicInfoItemText;
